import React, { useCallback } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUpload, FiImage, FiX } = FiIcons;

const PhotoUploader = ({ onImageUpload, isProcessing }) => {
  const handleFileUpload = useCallback((event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        onImageUpload(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  }, [onImageUpload]);

  const handleDrop = useCallback((event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        onImageUpload(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  }, [onImageUpload]);

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200"
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">Télécharger une photo</h2>
        <SafeIcon icon={FiUpload} className="w-5 h-5 text-purple-500" />
      </div>

      <div
        className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-purple-400 transition-colors cursor-pointer"
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onClick={() => document.getElementById('fileInput').click()}
      >
        <SafeIcon icon={FiImage} className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600 mb-2">
          Glissez-déposez votre image ici ou cliquez pour sélectionner
        </p>
        <p className="text-sm text-gray-500">
          Formats supportés: JPG, PNG, GIF
        </p>
      </div>

      <input
        id="fileInput"
        type="file"
        accept="image/*"
        onChange={handleFileUpload}
        className="hidden"
        disabled={isProcessing}
      />

      <div className="mt-4 p-4 bg-purple-50 rounded-lg">
        <h3 className="text-sm font-medium text-purple-900 mb-2">Conseils pour de meilleurs résultats :</h3>
        <ul className="text-sm text-purple-700 space-y-1">
          <li>• Utilisez des images avec des contrastes élevés</li>
          <li>• Évitez les photos trop détaillées</li>
          <li>• Les portraits et logos fonctionnent très bien</li>
        </ul>
      </div>
    </motion.div>
  );
};

export default PhotoUploader;